import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import Utils from "../../helper/utils";

export const UnderConstruction = () => {
  Utils.setDocumentTitle("Em Construção");

  return (
    <div className='CentralizedContainer' >
      <img src='/NotImplemented.gif' alt='Not Found' width='1920' height='1080' style={{ maxWidth: "100%", height: "auto" }} />
    </div>
  );
};
